"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deriveLineOffset = exports.deriveLineHeight = void 0;
var deriveLineHeight = function (_a) {
    var fontMetrics = _a.fontMetrics, fontSize = _a.fontSize;
    var unitsPerEm = fontMetrics.unitsPerEm, usWinAscent = fontMetrics.usWinAscent, usWinDescent = fontMetrics.usWinDescent;
    var span = usWinAscent + Math.abs(usWinDescent);
    return (span / unitsPerEm) * fontSize;
};
exports.deriveLineHeight = deriveLineHeight;
var deriveLineOffset = function (_a) {
    var fontMetrics = _a.fontMetrics, lineHeight = _a.lineHeight;
    var usWinAscent = fontMetrics.usWinAscent, usWinDescent = fontMetrics.usWinDescent;
    var span = usWinAscent + Math.abs(usWinDescent);
    return (usWinAscent / span) * lineHeight;
};
exports.deriveLineOffset = deriveLineOffset;
